<template>
    <div class="page">
        <div class="pay-success">
            <van-icon name="checked" size="24"/>
            <div class="success">支付成功</div>
        </div>
        <!-- <div class="pay-price">
            <div class="pay-static">￥</div>
            <div class="pay-price-number">{{ remark }}</div>
        </div> -->
        <!-- <div class="next" @click="linkTo">点我进入下一步激活流程</div> -->
        <van-button type="primary" block >请手动返回APP查询到账情况</van-button>
    </div>
</template>
<script>
import {Toast,Dialog} from 'vant';
import {wxRequest} from '@/api/user.js'
export default{
    data(){
        return{
            remark:''
        }
    },
    created(){
      
    },
    mounted(){
        let mchData ={action:'onIframeReady',displayStyle:'SHOW_CUSTOM_PAGE'} 
        let postData = JSON. stringify(mchData) 
        parent.postMessage(postData,'https://payapp.weixin.qq.com')

       
    },
    methods:{
        linkTo(){
            let mchData ={action:'jumpOut', jumpOutUrl:'http://wx.519liuliang.com/#/newUser/home'}
            let postData = JSON. stringify(mchData)
            parent.postMessage(postData,'https://payapp.weixin.qq.com')
            // Dialog.confirm({
            //     title: '即将打开商家的新页面',
            //     message: '小象通信',
            //     confirmButtonColor:'#07c26b'
            // }).then(() => {
            //         // on confirm
                   
            //     // this.$router.replace("/newUser/home");
            // }).catch(() => {
            //         // on cancel
            // });
        }
    }
}
</script>
<style lang="less" scoped>
.page{
    max-height:700px;
    min-height: 550px;
    background: #fff;
    position: relative;
    .pay-success{
        display: flex;
        justify-content:center;
        align-items: center;
        color: #07c26b;
        padding-top:100px;
        .success{
            padding-left:4px;
            font-size:16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 21px;
        }
    }
    .pay-price{
        display: flex;
        justify-content:center;
        align-items: end;
        padding-top:30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 600;
        .pay-static{
            font-size: 20px;

        }
        .pay-price-number{
            font-size: 26px;
        }
    }
    .next{
        color: rgb(7, 194, 107);
        text-align: center;
        cursor: pointer;
        font-size:12px;
        text-decoration: underline;
        margin-top:30px;
    }
    .van-button{
        width:80%;
        margin:0 auto;
        height: 36px;
        // position: absolute;
        top: 70%;
        margin-top:30px;
        left: 0;
        right: 0;
    }
}
</style>